module.exports = __webpack_public_path__ + "2c36af01bd1b63582885c6864c7a1edf.jpeg";